import { render, staticRenderFns } from "./CaseInstallementPlan.vue?vue&type=template&id=74c6e990&"
import script from "./CaseInstallementPlan.vue?vue&type=script&lang=js&"
export * from "./CaseInstallementPlan.vue?vue&type=script&lang=js&"
import style0 from "./CaseInstallementPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports